import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import trialContent from '../content/trialWelcomeContent.json';

function TrialWelcomeDialog({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, bgcolor: '#e3f2fd' }}>
        <InfoOutlinedIcon color="primary" />
        <span>{trialContent.title}</span>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Box component="ul" sx={{ pl: 2, '& li': { mb: 1.5 } }}>
          {trialContent.points.map((point, idx) => (
            <li key={idx}>
              <Typography variant="body2" color="text.secondary">
                {point}
              </Typography>
            </li>
          ))}
        </Box>
        {trialContent.footer && (
          <Typography variant="body2" sx={{ mt: 2, fontStyle: 'italic', color: 'primary.main' }}>
            {trialContent.footer}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Got it, let me explore!
        </Button>
      </DialogActions>
    </Dialog>
  );
}

TrialWelcomeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default TrialWelcomeDialog;
